// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__Y8SOt","right":"styles_right__2ifSj"};